import { InputTextDesignTokens } from '@primeuix/themes/aura/inputtext';

export const inputTextTokens: InputTextDesignTokens = {
  root: {
    background: '{form.field.background}',
    disabledBackground: '{form.field.disabled.background}',
    disabledColor: '{form.field.disabled.color}',
    filledBackground: '{form.field.filled.background}',
    filledFocusBackground: '{form.field.filled.focus.background}',
    filledHoverBackground: '{form.field.filled.hover.background}',
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    hoverBorderColor: '{form.field.hover.border.color}',
    focusBorderColor: '{form.field.focus.border.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
    color: '{form.field.color}',
    placeholderColor: '{form.field.placeholder.color}',
    shadow: '{form.field.shadow}',
    paddingX: '{form.field.padding.x}',
    paddingY: '{form.field.padding.y}',
    transitionDuration: '{form.field.transition.duration}',
    focusRing: {
      width: '{form.field.focus.ring.width}',
      style: '{form.field.focus.ring.style}',
      color: '{form.field.focus.ring.color}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
    sm: {
      fontSize: '0.875rem',
      paddingX: '{form.field.sm.padding.x}',
      paddingY: '{form.field.sm.padding.y}',
    },
    lg: {
      fontSize: '1.125rem',
      paddingX: '{form.field.lg.padding.x}',
      paddingY: '{form.field.lg.padding.y}',
    },
  },
};
